/**
 * Genemo アプリ一覧（家族共通の family-design/apps.ts を使う）と、ブランド画像・Short への導線。
 */

import { GENEMO_APPS, GENEMO_LEGAL_LINKS, GENEMO_OPERATOR, SOURCE_APP_TO_KEY, type GenemoApp, type GenemoAppKey } from '../../../family-design/apps'

export { GENEMO_APPS, GENEMO_LEGAL_LINKS, GENEMO_OPERATOR, SOURCE_APP_TO_KEY, type GenemoApp, type GenemoAppKey }

export const CURRENT_APP_KEY: GenemoAppKey = 'post'

// サイドバーに出すアプリ（Post 自身は除く）
export const LAUNCHER_APPS = GENEMO_APPS.filter(a => a.key !== CURRENT_APP_KEY)

// family-design/brand のマーク画像（ビルド時に Vite が解決する）
const marks = import.meta.glob('../../../family-design/brand/mark/*.png', { eager: true, import: 'default' }) as Record<string, string>
export const markUrl = (app: GenemoApp) => marks[`../../../family-design/brand/mark/${app.logo}-mark.png`]

// 上のバーとログイン画面のロゴ（Short と同じ形の「Genemo POST」）
export { default as postLogoUrl } from '../../../family-design/brand/logo/genemo-post.svg'

/** Genemo Short（IdP・決済の窓口）。クレジットの購入・新規登録・パスワード再設定はここへ遷移する */
export const SHORT_URL = GENEMO_APPS.find(a => a.key === 'short')!.url

/** Genemo Home（残高・プラン・請求履歴のまとめ）。残高の行き先 */
export const HOME_URL = GENEMO_APPS.find(a => a.key === 'home')!.url
